<template>
	<div></div>
</template>

<script>

export default {
	
	data(){
		return {			
			retUrl : '',
		}
	},

	mounted() {
		this.codeChk();
	},

	methods : {
		codeChk() {
			var urlStr = location.href;
			var url = new URL(urlStr);
			var urlParams = url.searchParams;
			var code = urlParams.get('code');
			
			if(code == null)  {
				this.loginWithKakao();
			}else {
				window.opener.setKakaoCode(code);
			}

			
		},

		loginWithKakao() {
			var urlOrigin = location.origin;
			var devKey = '4fe6efd8aecd391d818cb157a66c5c73';
			var prodKey = '1974e73639faf62dea1461e618b3ed63';
			
			// var useKey = devKey;
			// if(urlOrigin.indexOf('highpro') > 0) useKey = prodKey;

			var useKey = prodKey;
			if(urlOrigin.indexOf('localhost') > 0) useKey = devKey;

			var redUri = urlOrigin + '/MEM001P03';

			var uri = "https://kauth.kakao.com/oauth/authorize?";
				uri += "client_id="+useKey;
				uri += "&redirect_uri="+redUri;
				uri += "&response_type=code";

			location.href = uri;
		}
	}
}
</script>